module.exports = __webpack_public_path__ + "img/discussions.93149e2b.svg";